import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import { LeaseUpdateTablePageLoader } from "./LeaseUpdatePage/leasePages/LeaseUpdateTablePages/loaders";
import {
  LeaseUploadPageAction,
  LeaseUploadPageLoader,
} from "./LeaseUpdatePage/leasePages/LeaseUpdateTablePages/loaders/LeaseUpdatePageLoader";
import { FileModalContent } from "~/components/FileModalView";
import {
  LeaseDetailsPageLoader,
  LeaseDetailsPageAction,
} from "./LeaseInfoPage/loaders";
import {
  LeaseDetailsDocsLoader,
  LeaseDetailsDocsAction,
} from "./LeaseInfoPage/loaders/LeaseDetailsDocsLoader";
import {
  LeaseTablePageAction,
  LeaseTablePageLoader,
  leaseTableShouldRevalidate,
} from "./LeaseTablePage/loaders/LeaseTablePageloader";

const LeaseUpdateTablePage = lazyNamedPage("LeaseUpdateTablePage", () =>
  import(
    /* webpackChunkName: "lease" */
    "./LeaseUpdatePage/leasePages/LeaseUpdateTablePages/LeaseUpdateTablePage"
  ),
);
const LeaseUpdateDetailsPage = lazyNamedPage("LeaseUpdateDetailsPage", () =>
  import(
    /* webpackChunkName: "lease" */
    "./LeaseUpdatePage/leasePages/LeaseUpdateDetailsPage"
  ),
);
const LeaseUpdateForm = lazyNamedPage("LeaseUpdateForm", () =>
  import(
    /* webpackChunkName: "lease" */
    "./LeaseUpdatePage/leasePages/LeaseUpdateForm"
  ),
);
const LeaseDetailsPage = lazyNamedPage("LeaseDetailsPage", () =>
  import(
    /* webpackChunkName: "lease" */
    "./LeaseInfoPage/LeaseDetailsPage"
  ),
);
const LeaseTablePage = lazyNamedPage("LeaseTablePage", () =>
  import(
    /* webpackChunkName: "lease" */
    "./LeaseTablePage/LeaseTablePage"
  ),
);

export const LeasePagesRoutes = () => {
  return (
    <>
      <Route
        path="/lease/update/"
        loader={LeaseUpdateTablePageLoader}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<LeaseUpdateTablePage />}
      />

      <Route
        loader={LeaseUploadPageLoader}
        action={LeaseUploadPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        path="/lease/update/:leaseID"
        element={<LeaseUpdateDetailsPage />}
      />

      <Route
        loader={LeaseUploadPageLoader}
        action={LeaseUploadPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        path="/lease/update/:leaseID/form"
        element={<LeaseUpdateForm />}
      />

      <Route
        loader={LeaseDetailsPageLoader}
        action={LeaseDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        path="/lease/:leaseID"
        element={<LeaseDetailsPage />}
      >
        <Route
          loader={LeaseDetailsDocsLoader}
          action={LeaseDetailsDocsAction}
          ErrorBoundary={() => SimpleErrorBoundary()}
          path="/lease/:leaseID/docs"
          element={<FileModalContent />}
        />
      </Route>

      <Route
        loader={LeaseTablePageLoader}
        action={LeaseTablePageAction}
        shouldRevalidate={leaseTableShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        path="/lease"
        element={<LeaseTablePage />}
      />
    </>
  );
};
